import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';
import { styled } from '@mui/material/styles';

export const Scrollbar = styled(SimpleBar)``;
